"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.restoreBrace = exports.preserveBrace = exports.brace = void 0;
var preservation_1 = require("./preservation");
exports.brace = [];
// preserves strings inside curly braces (`{}`)
function preserveBrace(text) {
    return text.replace(/(\[.*?\])/g, function (matched) {
        exports.brace.push(matched);
        return preservation_1.preservation("brace");
    });
}
exports.preserveBrace = preserveBrace;
// bringing back braces
function restoreBrace(text) {
    return text.replace(new RegExp("[ ]?" + preservation_1.preservation("brace").trim() + "[ ]?", "g"), function () { return exports.brace.shift(); });
}
exports.restoreBrace = restoreBrace;
